import * as React from 'react';

export type FrozenCellWidthCache = Record<number, [number, boolean]>;

interface NewTableContextType {
  scrollableWrapperRef?: React.RefObject<HTMLDivElement>;
  frozenCellWidthCache: FrozenCellWidthCache;
}

const NewTableContext = React.createContext<NewTableContextType>({
  scrollableWrapperRef: undefined,
  frozenCellWidthCache: {},
});

export default NewTableContext;
